<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>{{ isPaused ? 'Unpause Game' : 'Cancel Scheduled Pause' }}</span>
  <ng-container dialog-content>
    @if (isPaused) {
      <p data-testid="unpause-game-paused-copy">
        {{ data.game.Name }} will return to active and draws will resume. A new draw is created on the next
        scheduled run, not immediately.
      </p>
    } @else {
      <p data-testid="unpause-game-pending-copy">
        {{ data.game.Name }} is scheduled to pause. Cancelling means the pause will not happen and draws
        continue as normal.
      </p>
    }
    @if (data.game.UnpauseOn) {
      <p data-testid="unpause-game-clears-date-copy">
        The unpause date of {{ data.game.UnpauseOn | date: 'yyyy-MM-dd h:mm a' }} will be cleared.
      </p>
    }
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary"
            data-testid="unpause-game-submit-button"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
